import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IoMdLocate } from "react-icons/io";
import { BiHide } from "react-icons/bi";
import { BiShow } from "react-icons/bi";
import { MdOutlineDeleteOutline, MdGesture } from "react-icons/md";

import "./card.css";
import StackedColumnChart from "../../widgets/PhiChart";
import { MdOutlinePolyline } from "react-icons/md";
import { PiPolygonBold } from "react-icons/pi";
import { BiShapeSquare } from "react-icons/bi";
import { RiCheckboxBlankCircleLine } from "react-icons/ri";

const Card2 = ({
    startLineCal,
    startAreaCal,
    resetPolys,
    getContour1,
    getContour2,
    clearContour,
    mapId,
    currentMapTypeIndex,
    toggleDraw,
    exportGeoJson,
    saveToDb,
    removeDrawnPoly,
    coords,
    setCoords,
    drawPolygonFromPoints,
    segmentVolume,
    recenter,
    getMap1,
    currentMapType,
    currMapData,
    selectOrthoRef,
    orthoMapOpacity,
    DSMMapOpacity,
    DTMMapOpacity,
    setOrthoMapOpacity,
    setDSMMapOpacity,
    setDTMMapOpacity,
    removeTopo,
    changeMap,
    startLineForElevation,
    fetchHeights,
    elevCoords,
    withinSegVolume,
    isCollapsed,
    drawingProps,
    handleClickFromList,
    deleteDrawing,
    buildTableHTML,
    toggleDrawingVisibility,
}) => {
    return (
        <div
            style={{
                // zIndex: 1000,

                // opacity: '1'
                // boxShadow: "1px 1px 7px 1px grey",
                width: isCollapsed ? "0%" : "20%",
                border: isCollapsed
                    ? "none"
                    : "0.5px solid var(--color-border)",
            }}
            id="caard"
            className={`card_container hideScrollbar`} // include close
        >
            <div
                href="#"
                style={{
                    // backgroundColor: "rgb(79 113 197)",
                    // width: isCollapsed ? "0%" : "100%",
                    height: "100%",
                    // display: isCollapsed ? 'none' : 'block'
                }}
                className="animate_transit"
                // className="block max-w-sm pl-6 pr-6 pt-2 bg-white border-gray-200 rounded shadow hover:bg-gray-100 overflow-scroll scrolling"
            >
                <div href="#" className="block pt-2 px-2 text-start">
                    <h5 className="text-white">Tools</h5>
                </div>
                <div>
                    <AccordionUsage
                        startLineCal={startLineCal}
                        startAreaCal={startAreaCal}
                        resetPolys={resetPolys}
                        getContour1={getContour1}
                        getContour2={getContour2}
                        clearContour={clearContour}
                        mapId={mapId}
                        currentMapTypeIndex={currentMapTypeIndex}
                        toggleDraw={toggleDraw}
                        exportGeoJson={exportGeoJson}
                        saveToDb={saveToDb}
                        removeDrawnPoly={removeDrawnPoly}
                        coords={coords}
                        setCoords={setCoords}
                        drawPolygonFromPoints={drawPolygonFromPoints}
                        segmentVolume={segmentVolume}
                        recenter={recenter}
                        getMap1={getMap1}
                        currentMapType={currentMapType}
                        currMapData={currMapData}
                        selectOrthoRef={selectOrthoRef}
                        orthoMapOpacity={orthoMapOpacity}
                        DSMMapOpacity={DSMMapOpacity}
                        DTMMapOpacity={DTMMapOpacity}
                        setOrthoMapOpacity={setOrthoMapOpacity}
                        setDSMMapOpacity={setDSMMapOpacity}
                        setDTMMapOpacity={setDTMMapOpacity}
                        removeTopo={removeTopo}
                        changeMap={changeMap}
                        startLineForElevation={startLineForElevation}
                        fetchHeights={fetchHeights}
                        elevCoords={elevCoords}
                        withinSegVolume={withinSegVolume}
                        drawingProps={drawingProps}
                        handleClickFromList={handleClickFromList}
                        deleteDrawing={deleteDrawing}
                        buildTableHTML={buildTableHTML}
                        toggleDrawingVisibility={toggleDrawingVisibility}
                    />
                </div>
                <div
                    style={{
                        position: "absolute",
                        top: "1%",
                        right: "2%",
                    }}
                ></div>
            </div>
        </div>
    );
};

function AccordionUsage({
    segmentVolume,

    withinSegVolume,
    drawingProps,
    handleClickFromList,
    deleteDrawing,
    buildTableHTML,
    toggleDrawingVisibility,
}) {
    return (
        <div>
            <hr className="mb-2" />

            <Accordion
                style={{
                    cssText:"background: rgb(33 37 41 / 38%) !important; color:var(--color-font); border:none !important;"
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "GrayText" }} />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <MdGesture size={24} color="var(--secondary-2)" /> &nbsp;
                    Drawings
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        className="d-flex gap-2"
                        style={{ flexDirection: "column" }}
                    >
                        {drawingProps.length !== 0 ? (
                            drawingProps?.map((prop, index) => {
                                return (
                                    <div
                                        className="d-flex flex-column"
                                        key={`drawing_${prop.label}`}
                                    >
                                        <Accordion
                                            style={{
                                            cssText:"background:#1a223861 !important;"
                                        }}
                                        >
                                            <AccordionSummary
                                                expandIcon={
                                                    <ExpandMoreIcon
                                                        sx={{
                                                            color: "GrayText",
                                                        }}
                                                    />
                                                }
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color:"var(--color-font)"
                                                    }}
                                                >
                                                    {prop.type ===
                                                    "polyline" ? (
                                                        <MdOutlinePolyline title="Polyline" color="var(--secondary-2)" />
                                                    ) : prop.type ===
                                                      "polygon" ? (
                                                        <PiPolygonBold title="Polygon" color="var(--secondary-2)" />
                                                    ) : prop.type ===
                                                      "rectangle" ? (
                                                        <BiShapeSquare title="Rectangle" color="var(--secondary-2)" />
                                                    ) : (
                                                        <RiCheckboxBlankCircleLine title="Circle" color="var(--secondary-2)" />
                                                    )}{" "}
                                                    &nbsp;
                                                    <span
                                                        style={{
                                                            color: "var(--secondary-2)",
                                                        }}
                                                    >
                                                        |
                                                    </span>
                                                    &nbsp;{" "}
                                                    <strong>
                                                        {index + 1}.
                                                    </strong>{" "}
                                                    &nbsp; {prop.label}
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: buildTableHTML(
                                                            prop.label,
                                                            prop.properties,
                                                            true
                                                        ),
                                                    }}
                                                ></div>
                                                <div className="btn-group" style={{width:"100%", marginTop:5}}>
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        onClick={() =>
                                                            handleClickFromList(
                                                                prop.label,
                                                                prop.properties,
                                                                prop.position
                                                            )
                                                        }
                                                    >
                                                        <IoMdLocate />
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary btn-sm"
                                                        onClick={() =>
                                                            toggleDrawingVisibility(
                                                                prop.label
                                                            )
                                                        }
                                                    >
                                                        {prop.visible ? (
                                                            <BiHide />
                                                        ) : (
                                                            <BiShow />
                                                        )}
                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() =>
                                                            deleteDrawing(
                                                                prop.label
                                                            )
                                                        }
                                                    >
                                                        <MdOutlineDeleteOutline />
                                                    </button>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                        
                                    </div>
                                );
                            })
                        ) : (
                            <p>No Drawing Data</p>
                        )}
                    </div>
                </AccordionDetails>
            </Accordion>

            {/* <div style={{ display: 'flex', flexDirection: 'column', padding: 10, justifyContent: "center", gap: 20, color: "white" }}>
                <label htmlFor="ortho-opacity">Ortho Opacity</label>
                <input type="range" id="ortho-opacity" min={0} max={1} step={0.1} onChange={(e) => {
                    setOrthoMapOpacity(e.target.value)
                    removeTopo("orthoPaths")
                    changeMap(currentMapTypeIndex, 'orthoPaths')
                }} />
                <label htmlFor="DSM-opacity">DSM Opacity</label>
                <input type="range" id="DSM-opacity" min={0} max={1} step={0.1} />
                <label htmlFor="DTM-opacity">DTM Opacity</label>
                <input type="range" id="DTM-opacity" min={0} max={1} step={0.1} />
            </div> */}
            {segmentVolume &&
                segmentVolume.length > 0 &&
                segmentVolume[0] !== null &&
                segmentVolume[1] !== null && (
                    // segmentVolume[0] === false ? <p style={{ color: "red" }} align="center">Something went wrong!</p> :
                    <StackedColumnChart
                        cutSeg={segmentVolume[0].toFixed(2)}
                        fillSeg={segmentVolume[1].toFixed(2)}
                        cutPoly={
                            withinSegVolume && withinSegVolume[0]
                                ? withinSegVolume[0]?.toFixed(2)
                                : 0
                        }
                        fillPoly={
                            withinSegVolume && withinSegVolume[1]
                                ? withinSegVolume[1]?.toFixed(2)
                                : 0
                        }
                    />
                )}
            {/* <StackedColumnChart /> */}
        </div>
    );
}
export default Card2;
